export default __webpack_public_path__ + "static/media/note_3_1013_1.977072c1.nproj";